/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Radio, Tabs } from "antd";
import Breadcrumbs from "@components/Breadcumbs";
import LogisticService from "@LogisticService";
import OmAnexos from "@assets/imgs/OmAnexos.svg";
import AutonomiaAnexos from "@assets/imgs/AutonomiaAnexos.svg";
import BottomArrow from "@assets/icons/BottomArrow";
import ReportAnexos from "@assets/imgs/ReportAnexos.svg";
import Icon from "@components/Icon";
import Row from "@components/Row";
import Colors from "@colors";
import ImagensOm from "./detalhes/imagensOM";
import ImagensAutonomia from "./detalhes/imagensAutonomia";
import PageHeader from "@components/PageHeader";
import useRouter from "../../../hooks/useRouter";
import AttachmentServiceOrder from "./AttachmentServiceOrder";
import AttachmentStoneEntrega from "./AttachmentStoneEntrega";
import { getAllHubs } from "../../../features/senninha/hubsSlice";
import { BackButton } from "./styles";
import { PageLayout } from "../../../Layout/PageLayout";
import { InventoryAudit } from "./InventoryAudit";
import { useDispatch } from "react-redux";

import * as S from "./styles";

const AnexosOSs = () => {
	const { TabPane } = Tabs;
	const [numeroOM, setNumeroOM] = useState(null);
	const [numeroAutonomia, setNumeroAutonomia] = useState(null);
	const [checkboxValue, setCheckboxValue] = useState("Serial ou E-mail");
	const [nomeDistritos, setNomeDistritos] = useState("");
	const { push } = useRouter();

	const dispatch = useDispatch();

	const voltarOM = () => setNumeroOM(null);
	const voltarAutonomia = () => setNumeroAutonomia(null);

	useEffect(() => {
		dispatch(getAllHubs());
	}, [dispatch]);

	const category = [
		{ label: "Serial ou E-mail", value: "Serial ou E-mail" },
		{ label: "distrito", value: "Distrito" },
	];

	useEffect(() => {
		LogisticService.getTodosOsDistritos().then((response) => {
			if (response) {
				setNomeDistritos(response.data);
			}
		});
	}, []);

	function handleChangeCheckbox(checkedValues) {
		setCheckboxValue(checkedValues.target.value);
	}

	const searchHistoricDOA = (e) => {
		push(`/ferramentas/anexos/consulta-doa/${e}`);
	};

	const handleChangeDistrito = (value) => {
		searchHistoricDOA(value);
	};

	const optionsTabs = [
		{
			label: "ORDEM DE SERVIÇO",
			key: "1",
			content: <AttachmentServiceOrder />
		},
		{
			label: "LOG LOJISTA",
			key: "2",
			content: <AttachmentStoneEntrega />
		},
		{
			label: "ORDEM DE MOVIMENTAÇÃO",
			key: "3",
			content: numeroOM ? (
				<>
					<Row hidden={!numeroOM}>
						<BackButton onClick={voltarOM}>
							<Icon color={Colors.white} name="angle-left" /> voltar
						</BackButton>
					</Row>
					<ImagensOm numeroOM={numeroOM} voltarOM={voltarOM} />
				</>
			) : (
				<S.ContentAnexos>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
						}}
					>
						<img src={OmAnexos} alt="OM Anexos" />
						<S.SubtitleAnexos>Consultar OM - Trucker App</S.SubtitleAnexos>
						<S.SearchInputAnexos
							onSearch={(e) => {
								setNumeroOM(e);
							}}
							placeholder="Insira o número da OM"
						/>
					</div>
				</S.ContentAnexos>
			),
		},
		{
			label: "ORDEM DE SERVIÇO AUTONOMIA",
			key: "4",
			content: numeroAutonomia ? (
				<>
					<Row hidden={!numeroAutonomia}>
						<BackButton onClick={voltarAutonomia}>
							<Icon color={Colors.white} name="angle-left" /> voltar
						</BackButton>
					</Row>
					<ImagensAutonomia
						numeroAutonomia={numeroAutonomia}
						voltarAutonomia={voltarAutonomia}
					/>
				</>
			) : (
				<S.ContentAnexos>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
						}}
					>
						<img src={AutonomiaAnexos} alt="Autonomia Anexos" />
						<S.SubtitleAnexos>Consultar OS - Green App</S.SubtitleAnexos>
						<S.SearchInputAnexos
							onSearch={(e) => {
								setNumeroAutonomia(e);
							}}
							placeholder="Insira o número da OS"
						/>
					</div>
				</S.ContentAnexos>
			),
		},
		{
			label: "CONSULTA DE REPORT DOA",
			key: "5",
			content: (
				<S.ContentAnexos>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
						}}
					>
						<img src={ReportAnexos} alt="Report Anexos" />
						<S.SubtitleAnexos>Consultar OS - Green App</S.SubtitleAnexos>
						{checkboxValue === "Serial ou E-mail" ? (
							<S.SearchInputAnexos
								anexoDoa
								onSearch={searchHistoricDOA}
								placeholder="Insira o serial ou e-mail"
							/>
						) : (
							<S.SelectAnexos
								placeholder="Selecione um distrito"
								suffixIcon={
									<BottomArrow
										color={"#767F8D"}
										size={24}
										style={{ marginLeft: "-14px", marginTop: "-6px" }}
									/>
								}
								onChange={handleChangeDistrito}
								showSearch
							>
								{Array.isArray(nomeDistritos) &&
									nomeDistritos.map((option) => (
										<Option key={option.id} value={option.name}>
											{option.name}
										</Option>
									))}
							</S.SelectAnexos>
						)}
						<S.CheckboxAnexosContent>
							{category.map((item) => (
								<Radio
									key={item.label}
									onChange={handleChangeCheckbox}
									checked={item.value === checkboxValue}
									value={item.value}
									className="ginga-radio"
								>
									{item.value}
								</Radio>
							))}
						</S.CheckboxAnexosContent>
					</div>
				</S.ContentAnexos>
			),
		},
		{
			label: "Auditoria de inventário",
			key: "6",
			content: <InventoryAudit />,
		},
	];

	return (
		<PageLayout>
			<div>
				<Breadcrumbs />
				<PageHeader title="Anexos" />
				<S.ContainerAnexos>
					<S.TabsOptions centered className="ginga-tab">
						{optionsTabs.map((option) => (
							<TabPane tab={option.label} key={option.key}>
								{option.content}
							</TabPane>
						))}
					</S.TabsOptions>
				</S.ContainerAnexos>
			</div>
		</PageLayout>
	);
};

export default AnexosOSs;
